import {Injectable} from '@angular/core';
import {ResolutionResponse, ResolutionStatus, SolutionInfoResponse} from '@npck/af-frontend-api';
import {formatDateTimeFromServerToUi, formatFromServerToUi} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {StatusStyle} from '../components/status/status.component';
import {AttachmentViewModel} from '../pages/incidents/details/documents-tab/documents-tab.component';
import {formatPhone} from './phone-utils';

@Injectable({
    providedIn: 'root',
})
export class ResolutionService {

    private fields: ResolutionFieldNames = [
        'createdDate',
        'createdBy',
        'updatedDate',
        'updatedBy',
        'organization',
        'investigatorFullName',
        'investigatorPhoneNumber',
        'unifiedRegisterNumber',
        'unifiedRegisterDate',
        'comment',
    ];

    // TODO Move to frontend/projects/af/src/app/domain/field-builder.service.ts
    fieldBuilder(data: ResolutionResponse): ResolutionFields[] {
        const hasUpdate = !!data.updatedDate && data.createdDate !== data.updatedDate;
        return this.fields
            .filter(fieldName => hasUpdate || (fieldName !== 'updatedDate' && fieldName !== 'updatedBy'))
            .map(fieldName => {
                let value = (data as any)[fieldName];
                if (fieldName === 'unifiedRegisterDate') {
                    value = value && formatFromServerToUi(dayjs(value));
                } else if (fieldName === 'createdDate' || fieldName === 'updatedDate') {
                    value = value && formatDateTimeFromServerToUi(dayjs(value));
                } else if (fieldName === 'investigatorPhoneNumber') {
                    value = value && formatPhone(value);
                }
                return {
                    fieldName: fieldName,
                    fieldValue: value || '-',
                };
            });
    }

}

export declare type ResolutionFieldNames = (keyof ResolutionResponse)[];

export interface Resolution {
    id: string;
    fields: ResolutionFields[];
    createdDate: string;
    status: ResolutionStatus;
    statusStyle: StatusStyle;
    isInnocentStatus: boolean
    attachments: AttachmentViewModel[];
    solutionInfo?: SolutionInfoResponse[];
}

export interface ResolutionFields {
    fieldName: string;
    fieldValue: string;
}
